import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import { restructureData } from "../../../../utils/restructureData";
import StaticColumn from "./StaticColumn";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import { validateLeadershipTable } from "../../../../utils/validateTable";

const GRI303_3 = ({ hide }) => {
  const [table, setTable] = useState([]);
  const [table1, setTable1] = useState([]);
  const [table2, setTable2] = useState([]);

  const inputData = [
    [
      {
        fieldName: "totalWaterWithdrawalByDestination",
        type: "array",
        tables: table,
        title: "a. Total water withdrawal to all areas in kiloliters.",
        setTables: setTable,
        defaultSegments: [
          "Surface Water",
          "Groundwater/Seawater",
          "Produced Water",
          "Third-party water ",
        ],
        paramater: "destination",
        fields: [
          {
            fieldName: "destination",
            title: "Destination",
            type: "text",
            placeholder: "Enter Text",
            width: "18%",
          },
          {
            fieldName: "response",
            title: "Response",
            type: "text",
            width: "20%",
            placeholder: "Enter Text",
          },
          {
            fieldName: "quantity",
            title: "Quantity",
            type: "number",
            width: "15%",
            placeholder: "Enter Number",
          },
          // {
          //   fieldName: "unit",
          //   title: "Unit",
          //   type: "select",
          //   options: ["m3", "megaliters"],
          //   width: "18%",
          //   placeholder: "Select",
          // },
          {
            fieldName: "remark",
            title: "Remark",
            type: "text",
            width: "25%",
            placeholder: "Enter Text",
          },
        ],
      },
    ],
    [
      {
        fieldName: "waterWithdrawalInWaterStressAreas",
        title:
          "b. Total water withdrawal from all areas with water stress in kiloliters",
        type: "array",
        tables: table1,
        setTables: setTable1,
        defaultSegments: [
          "Surface Water",
          "Groundwater/Seawater",
          "Produced Water",
          "Third-party water ",
        ],
        paramater: "destination",
        fields: [
          {
            fieldName: "destination",
            title: "Destination",
            type: "text",
            placeholder: "Enter Text",
            width: "18%",
          },
          {
            fieldName: "response",
            title: "Response",
            type: "text",
            width: "20%",
            placeholder: "Enter Text",
          },
          {
            fieldName: "quantity",
            title: "Quantity",
            type: "number",
            width: "15%",
            placeholder: "Enter Number",
          },
          // {
          //   fieldName: "unit",
          //   title: "Unit",
          //   type: "select",
          //   options: ["m3", "megaliters"],
          //   width: "18%",
          //   placeholder: "Select",
          // },
          {
            fieldName: "remark",
            title: "Remark",
            type: "text",
            width: "25%",
            placeholder: "Enter Text",
          },
        ],
      },
    ],
    [
      {
        fieldName: "allAreasWater",
        title:
          "Total of water withdrawal from each of the sources listed in 303-3-a and 303-3-b in kiloliters by following categories",
        type: "array",
        letter: "c.",
        tables: table2,
        setTables: setTable2,
        defaultSegments: ["Freshwater", "Other Water"],
        defaultSegments2: ["< 1000mg/L TDS", "> 1000mg/L TDS"],
        paramater: "withdrawal",
        paramater2: "range",

        fields: [
          {
            fieldName: "withdrawal",
            title: "Water Withdrawal",
            type: "text",
            placeholder: "Enter Text",
            width: "18%",
          },
          {
            fieldName: "range",
            title: "Range",
            type: "percentage",
            width: "18%",
            placeholder: "Enter Text",
          },
          {
            fieldName: "quantity",
            title: "Quantity",
            type: "number",
            width: "15%",
            placeholder: "Enter Number",
          },
          // {
          //   fieldName: "unit",
          //   title: "Unit",
          //   type: "select",
          //   options: ["m3", "megaliters"],
          //   width: "18%",
          //   placeholder: "Select",
          // },
          {
            fieldName: "remark",
            title: "Remark",
            type: "text",
            width: "25%",
            placeholder: "Enter Text",
          },
        ],
      },
    ],
  ];

  const questionData = [
    {
      fieldName: "contextualInformation",
      title:
        "d. Provide contextual information necessary to understand how the data have been compiled, such as any standards, methodologies, and assumptions used.",
      type: "text",
      placeholder: "Enter Text",
      // letter: "d.",
    },
  ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [tabErrors, setTabErros] = useState({});
  const [defaultUnit, setDefaultUnit] = useState("");
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({ contextualInformation: "" });
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [griReview, setGriReview] = React.useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const handleStorage = () => setGriReview(JSON.parse(localStorage.getItem("griReview")));
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI300`);
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      const res1 = res?.data?.data?.GRI300?.waterWithdrawal;
      setDefaultUnit(
        res?.data?.data?.GRI300?.sharedResource?.waterInteraction?.[0]?.unit
      );
      setData(res1);
      setFormData({
        contextualInformation: res1?.contextualInformation || "",
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // let v1=validateLeadershipTable(inputData[0], table, setTabErros,"totalWaterWithdrawalByDestination","destination",);
      // let v2 = validateLeadershipTable(inputData[1], table1, setTabErros,"waterWithdrawalInWaterStressAreas","destination",);
      // let v3 = validateLeadershipTable(inputData[2], table2, setTabErros,"allAreasWater","withdrawal","range");

      // console.log(v1,v2,v3,"check")
      // if (!v1 || !v3 ||!v2) return;

      let transformedData2 = {
        waterWithdrawal: {
          ...restructureData(table),
          ...restructureData(table1),
          ...restructureData(table2),
          ...formData,
        },
        submitted303_3: true,
        type: "GRI300",
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/gri300/303-4/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri300/303-4/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {!hide && (
        <p className={styles.section_heading}>303 : Water & Effluents</p>
      )}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1rem" : "0" }}
      >
        303-3 : water withdrawal{" "}
      </p>
      {/* a */}
      <Box sx={{ marginTop: "-0.5rem" }}>
        {inputData?.map((el) => (
          <Box>
            <StaticColumn
              {...{
                inputData: el,
                tables: el[0].tables,
                setTables: el[0].setTables,
                errors: tabErrors?.[el?.[0]?.fieldName] || {},
                setErrors: setTabErros,
                data: data,
                defaultSegments: el[0]?.defaultSegments,
                defaultSegments2: el[0]?.defaultSegments2 || "",
                parameter: el[0]?.paramater,
                parameter2: el[0]?.paramater2 || "",
                totalField: "quantity",
                defaultUnit,
                setDefaultUnit,
                defaultField: "unit",
                id: id,
                disabled: disabled,
              }}
            />
          </Box>
        ))}
      </Box>
      {questionData.map((el) => (
        <Box sx={{ mt: hide ? "-1rem" : "1rem" }}>
          <Box sx={{ display: "flex", gap: 0.5 }}>
            {/* <p className={styles.ques_heading}>{el.letter}</p> */}
            <p className={styles.ques_heading}>{el.title}</p>
          </Box>
          <Box sx={{ ml: 2.5, width: "97%" }}>
            <InputField
              placeholder={"Enter Text"}
              fieldName={el.fieldName}
              value={formData?.[el.fieldName]}
              handleChange={handleChange}
              mt="-5px"
              disabled={disabled}
            />
          </Box>
        </Box>
      ))}
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI303_3;
